import ArchivedTeachers from './ArchivedTeachers';export default ArchivedTeachers;